(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     GAUDIR HEADER JS — NATIVE INTEGRATION EDITION
     Tres responsabilidades:
       1. Mostrar/ocultar gh-panel cuando hover-disclosure abre/cierra
       2. Mantener el panel abierto mientras el mouse cruza el gap
       3. Hacer el header sólido mientras el panel está visible
     ──────────────────────────────────────────────────────────── */

  var panels = document.querySelectorAll('.gh-panel');
  if (!panels.length) return;

  var headerEl        = document.querySelector('[data-header-height]');
  var headerComponent = document.querySelector('header-component');
  var nav             = document.querySelector('.header__menu');

  if (!headerEl || !nav) return;

  /* ── Mapa de panels por key ── */
  var panelMap = {};
  panels.forEach(function (panel) {
    var key = panel.dataset.ghPanel;
    if (key) panelMap[key] = panel;
  });

  /* ── Handleize: igual que el filtro Liquid ── */
  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[àáâãä]/g, 'a').replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i').replace(/[òóôõö]/g, 'o')
      .replace(/[ùúûü]/g, 'u').replace(/[ñ]/g, 'n')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* ── Posiciona el panel justo bajo el header ── */
  function updatePosition(panel) {
    var top = Math.round(headerEl.getBoundingClientRect().bottom);
    panel.style.setProperty('--gh-panel-top', top + 'px');
  }

  /* ── Sincroniza --HEADER-HEIGHT-MOBILE con la altura real del header ──
     El header sticky puede cambiar de altura en scroll (el toolbar se oculta,
     el header se compacta). El valor generado por Liquid es estático y no se
     actualiza solo. El drawer del hamburguesa usa esta variable para calcular
     su top y su height; si no se corrige aquí, queda cortado detrás del
     header después de hacer scroll.
   ── */
  function syncMobileHeight() {
    var h = Math.round(headerEl.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--HEADER-HEIGHT-MOBILE', h + 'px');
    }
  }

  var activePanel      = null;
  var activeDisclosure = null;
  var closeTimer       = null;

  /* ── Abrir ── */
  function showPanel(panel, disclosure) {
    clearTimeout(closeTimer);

    if (activePanel && activePanel !== panel) {
      doClose();
    }

    if (disclosure) disclosure.classList.add('gh-has-panel');

    updatePosition(panel);
    panel.classList.add('gh-panel--open');

    if (headerComponent) headerComponent.classList.add('gh-panel-open');

    activePanel      = panel;
    activeDisclosure = disclosure;
  }

  /* ── Cerrar (inmediato) ── */
  function doClose() {
    if (!activePanel) return;
    activePanel.classList.remove('gh-panel--open');
    if (activeDisclosure) activeDisclosure.classList.remove('gh-has-panel');
    if (headerComponent) headerComponent.classList.remove('gh-panel-open');
    activePanel      = null;
    activeDisclosure = null;
  }

  /* ── Cerrar con delay (permite cruzar el gap nav->panel) ── */
  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(doClose, 200);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  /* ── Conectar cada hover-disclosure ── */
  nav.querySelectorAll('hover-disclosure').forEach(function (disclosure) {
    var navtext = disclosure.querySelector('a[data-top-link] .navtext');
    if (!navtext) return;

    var key   = handleize(navtext.textContent.trim());
    var panel = panelMap[key];
    if (!panel) return;

    /* Observa aria-expanded: el tema lo gestiona, nosotros reaccionamos */
    new MutationObserver(function () {
      if (disclosure.getAttribute('aria-expanded') === 'true') {
        showPanel(panel, disclosure);
      } else {
        scheduleClose();
      }
    }).observe(disclosure, { attributes: true, attributeFilter: ['aria-expanded'] });

    /* Bridge hover: mantiene el panel abierto mientras el mouse esta en el nav item */
    disclosure.addEventListener('mouseenter', cancelClose);
    disclosure.addEventListener('mouseleave', scheduleClose);
  });

  /* ── Bridge hover: mantiene el panel abierto mientras el mouse esta sobre el ── */
  panels.forEach(function (panel) {
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);
  });

  /* ── Scroll: cierra el panel (desktop) y actualiza la altura mobile ──
     Cerrar en scroll elimina el desfase visual entre animacion del header
     y el repaint del panel. syncMobileHeight mantiene el drawer mobile
     correctamente posicionado mientras el sticky header cambia de altura.
  ── */
  window.addEventListener('scroll', function () {
    if (activePanel) {
      clearTimeout(closeTimer);
      doClose();
    }
  }, { passive: true });

  /* ── Resize: reposiciona el panel y sincroniza la altura mobile ── */
  if ('ResizeObserver' in window) {
    new ResizeObserver(function () {
      syncMobileHeight();
      if (activePanel) updatePosition(activePanel);
    }).observe(headerEl);
  }

  /* ── Escape ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      clearTimeout(closeTimer);
      doClose();
    }
  });

  /* ── Detectar apertura/cierre del menú móvil (hamburguesa) ── */
  var mobileToggle = document.querySelector('[data-drawer-toggle="hamburger"]') ||
                     document.querySelector('[aria-controls="header-menu"]') ||
                     document.querySelector('[aria-controls="menu-drawer"]') ||
                     document.querySelector('[aria-controls="mobile-menu"]') ||
                     document.querySelector('.header__menu-toggle') ||
                     document.querySelector('.header__hamburger') ||
                     document.querySelector('.hamburger') ||
                     document.querySelector('.mobile-menu-toggle') ||
                     document.querySelector('.mobile-nav-toggle') ||
                     document.querySelector('.js-mobile-menu-toggle');
  var mobileDrawer = document.getElementById('menu-drawer') ||
                     document.getElementById('header-menu') ||
                     document.getElementById('mobile-menu') ||
                     document.getElementById('nav-drawer') ||
                     document.querySelector('menu-drawer') ||
                     document.querySelector('.menu-drawer') ||
                     document.querySelector('.mobile-menu-drawer') ||
                     document.querySelector('.header__menu-drawer');

  function checkThemeClasses() {
    var classes = [
      'js-menu-open', 'menu-open', 'drawer-open', 'js-drawer-open', 
      'menu-is-open', 'drawer-is-open', 'nav-open', 'js-nav-open',
      'mobile-menu-open', 'header-menu-open', 'js-mobile-menu-open',
      'is-active', 'menu-active', 'drawer--active', 'drawer--opened',
      'has-menu-open', 'has-drawer-open'
    ];
    
    if (document.body) {
      for (var i = 0; i < classes.length; i++) {
        if (document.body.classList.contains(classes[i])) {
          return true;
        }
      }
    }
    if (document.documentElement) {
      for (var j = 0; j < classes.length; j++) {
        if (document.documentElement.classList.contains(classes[j])) {
          return true;
        }
      }
    }
    return false;
  }

  function setMobileMenuState(isOpen) {
    isOpen = isOpen || checkThemeClasses();
    if (isOpen) {
      document.documentElement.classList.add('gh-mobile-menu-open');
    } else {
      document.documentElement.classList.remove('gh-mobile-menu-open');
    }
  }

  if (mobileToggle) {
    var toggleObserver = new MutationObserver(function () {
      var isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) syncMobileHeight();
      setMobileMenuState(isOpen);
    });
    toggleObserver.observe(mobileToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
  }

  if (mobileDrawer) {
    var drawerObserver = new MutationObserver(function () {
      var isOpen = mobileDrawer.classList.contains('is-open') || 
                   mobileDrawer.classList.contains('drawer--opened') ||
                   mobileDrawer.classList.contains('drawer--active') ||
                   mobileDrawer.classList.contains('active') ||
                   mobileDrawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) syncMobileHeight();
      setMobileMenuState(isOpen);
    });
    drawerObserver.observe(mobileDrawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  }

  // Escucha clics globales para reaccionar a cualquier overlay o botón de cierre
  document.addEventListener('click', function () {
    setTimeout(function () {
      var isOpen = (mobileToggle && mobileToggle.getAttribute('aria-expanded') === 'true') ||
                   (mobileDrawer && (mobileDrawer.classList.contains('is-open') || 
                                     mobileDrawer.classList.contains('drawer--opened') ||
                                     mobileDrawer.classList.contains('drawer--active') ||
                                     mobileDrawer.classList.contains('active') ||
                                     mobileDrawer.getAttribute('aria-hidden') === 'false'));
      if (isOpen) syncMobileHeight();
      setMobileMenuState(isOpen);
    }, 100);
  });

  /* ── Sincronizacion inicial: corrige el valor estatico del Liquid ── */
  syncMobileHeight();

})();

